import { Vec2 } from '../../../consts/types';
import bunnySrc from '../../../images/svg/bunny.svg';

interface BunnyProps {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  parentElement: HTMLElement;
  onResize: () => void;
}

const Bunny = ({ canvas, ctx, parentElement, onResize }: BunnyProps) => {
  let pointerPos: Vec2 | undefined = undefined;
  let angle = 0;
  let bunnyAni = false;

  const bunny = {
    x: 0,
    y: 0,
    id: 'bunnbunn',
    width: 150,
    height: 300,
    isPointerInside: (x: number, y: number) => {
      return (
        x >= bunny.x && x <= bunny.x + bunny.width && y >= bunny.y && y <= bunny.y + bunny.height
      );
    }
  };

  const bunnyImg: HTMLImageElement = new Image();
  bunnyImg.src = bunnySrc;

  const setPointerPos = (e: TouchEvent | MouseEvent) => {
    if (typeof (e as TouchEvent).touches !== 'undefined') {
      pointerPos = {
        x: (e as TouchEvent).touches[0].pageX - parentElement.offsetLeft,
        y: (e as TouchEvent).touches[0].pageY - parentElement.offsetTop
      };
    } else {
      pointerPos = {
        x: (e as MouseEvent).pageX - parentElement.offsetLeft,
        y: (e as MouseEvent).pageY - parentElement.offsetTop
      };
    }
  };

  const unsetPointerPos = () => {
    pointerPos = undefined;
  };

  const tick = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (pointerPos && bunny.isPointerInside(pointerPos.x, pointerPos.y)) {
      bunnyAni = true;
      if (bunny.y > canvas.height - bunny.height * 0.93) bunny.y -= 6.7;
    } else {
      if (bunnyAni) {
        if (bunny.y < canvas.height + bunny.height) {
          bunny.y += 2.7;
          angle += 0.1;
        } else bunnyAni = false;
      } else {
        bunny.x = Math.round(
          (canvas.width / 2) * Math.sin((angle * Math.PI) / 180) + canvas.width / 2
        );
        bunny.y = Math.round(
          (bunny.height / 2) * Math.sin((Math.pow(angle, 1.3) * Math.PI) / 180) + canvas.height
        );
        angle += 0.4;
        if (angle > 720) angle -= 720;
      }
    }
    ctx.drawImage(bunnyImg, bunny.x, bunny.y, bunny.width, bunny.height);
    requestAnimationFrame(tick);
  };
  tick();

  window.addEventListener('resize', () => {
    onResize();
  });

  parentElement.addEventListener('mousemove', setPointerPos);
  parentElement.addEventListener('mouseleave', unsetPointerPos);

  parentElement.addEventListener('touchmove', setPointerPos);
  parentElement.addEventListener('touchend', unsetPointerPos);
};
export default Bunny;
